module.exports = __webpack_public_path__ + "src/assets/images/tips.png?0411e5a895b45ca99990e5b0fe144373";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tips.png
// module id = 1063
// module chunks = 1